import React from 'react';
import Dropzone from '../../Dropzone';
import FieldError from '../FieldError';
import FieldWrapper from '../FieldWrapper';
import Label from '../Label';

// eslint-disable-next-line
const FormikDropzoneField = ({ field, form, label, hidden, ...other }) => {
  return (
    <FieldWrapper hidden={hidden}>
      {label && <Label>{label}</Label>}
      <Dropzone
        label={label}
        hidden={hidden}
        hasError={(field.name in form.touched) && (field.name in form.errors)}
        onFilesChange={(files) => {
          form.setFieldValue(field.name, files);
        }}
        {...field}
        {...other}
      />
      {form.errors[field.name] && form.touched[field.name]
        && <FieldError>{form.errors[field.name]}</FieldError>}
    </FieldWrapper>

  );
};

export default FormikDropzoneField;
